var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"message"},[_c('div',{staticClass:"text-center"},[_c('b-icon',{attrs:{"icon":"inbox","font-scale":"3","animation":"fade"}}),_c('div',{domProps:{"innerHTML":_vm._s(_vm.modeView())}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }